<template>
  <div class="animated fadeIn" id="projectsRoot">
    <div class="row">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-header" v-if="showHeader">
            <i class="fa fa-align-justify"></i> Projects
          </div>
          <div class="card-block" v-if="showCategoryFilter">
            <ProjectCategoryFilter v-model="categoryFilter"></ProjectCategoryFilter>
          </div>
          <div class="card-block">
            <button class="btn btn-primary btn-sm new-user-btn" v-if="showNewProject" @click="newProject()"><i
                class="fa fa-plus"></i> New project</button>
            <table class="table table-bordered table-striped table-condensed">
              <thead>
                <tr>
                  <!--<th>#</th>-->
                  <!--<th>Key</th>-->
                  <th class="text-center">Name</th>
                  <th class="text-center">Type</th>
                  <th class="text-center">Category</th>
                  <th class="text-center">Client</th>
                  <th class="text-center">Start Date</th>
                  <th class="text-center">End Date</th>
                  <th class="text-right">Baseline Costs</th>
                  <th class="text-right">Additional actuals</th>
                  <th class="text-center">Contingency</th>
                  <th class="text-right">Contract budget</th>
                  <th>Contract Nr.</th>
                  <th class="text-right">Payment Due (days)</th>
                  <th class="text-right">VAT (%)</th>
                  <th class="text-center">Actions</th>
                </tr>
              </thead>
              <tbody>
                <span class="span-row" v-if="showProject(project.id)" :key="index" v-for="(project, index) in projects">
                  <tr>
                    <!--<td>{{project.id}}</td>-->
                    <!--<td>{{project.key}}</td>-->
                    <td><span @click="openProject(project.id)">{{ project.name }}</span></td>
                    <td class="text-center align-middle">{{ project.projectTypeKey }}</td>
                    <td class="text-center align-middle"
                      :title="project.category_id ? projectCategories[project.category_id].description : ''">
                      {{ project.category_id ? projectCategories[project.category_id].name : '' }}</td>
                    <td>{{ clientName(project.client_id) }}</td>
                    <td class="text-center align-middle">{{ project.start_date }}</td>
                    <td class="text-center align-middle">{{ project.end_date }}</td>
                    <!--<td>{{project.baseline_costs ? project.baseline_costs.toFixed(2) : ""}}</td>-->
                    <!--<td>{{project.contingency ? project.contingency.toFixed(2) : ""}}</td>-->
                    <!--<td>{{project.contract_budget ? project.contract_budget.toFixed(2) : ""}}</td>-->
                    <td class="text-right text-monospace align-middle">{{ project.baseline_costs ?
                        numberWithSpaces(project.baseline_costs.toFixed(2)) : "0.00"
                    }}</td>
                    <td class="text-right text-monospace align-middle">{{ project.additional_actuals ?
                        numberWithSpaces(project.additional_actuals.toFixed(2)) : "0.00"
                    }}</td>
                    <td>{{ project.contingency ? numberWithSpaces(project.contingency.toFixed(2)) : "" }}</td>
                    <td class="text-right text-monospace align-middle">{{ project.contract_budget ?
                        numberWithSpaces(project.contract_budget.toFixed(2)) : "0.00"
                    }}</td>
                    <template>
                      <td v-if="project.contract" class="align-middle cursor-pointer"
                        @click="editContract(project.contract.id)">{{ project.contract.contract_number }}</td>
                      <td v-else class="align-middle"></td>
                    </template>
                    <td class="text-right text-monospace align-middle">{{ project.payment_due_days }}</td>
                    <td class="text-right text-monospace align-middle">{{ project.vat_rate }}</td>
                    <td class="align-middle">
                      <i class="fa fa-edit fa-lg action" @click="editProject(project)" title="Edit project"></i>
                      <i class="fa fa-refresh fa-lg action" @click="UPDATE_PROJECT_META(project.id)" aria-hidden="true"
                        title="Update project metadata"></i>
                    </td>
                  </tr>
                  <tr v-for="(request, req) in project.change_requests" :key="req"
                    v-if="project.change_requests.length">
                    <td class="align-td-left" colspan="4">
                      <input v-if="request.editMode" class="input-max-width" placeholder="Enter name" type="text"
                        v-model="request.name">
                      <span v-if="!request.editMode">{{ request.name }}</span>
                    </td>
                    <td class="align-td-left text-center">
                      <datepicker v-if="request.editMode" input-class="update-change-request-date-picker"
                        placeholder="yyyy-mm-dd" :disabled-dates="{ from: new Date(request.end_date) }"
                        v-model="request.start_date" format="yyyy-MM-dd"></datepicker>
                      <span class="text-nowrap" v-if="!request.editMode">{{ request.start_date }}</span>
                    </td>
                    <td class="align-td-left text-center">
                      <datepicker v-if="request.editMode" input-class="update-change-request-date-picker"
                        placeholder="yyyy-mm-dd" :disabled="!request.start_date"
                        :disabled-dates="{ to: new Date(request.start_date) }" v-model="request.end_date"
                        format="yyyy-MM-dd"></datepicker>
                      <span class="text-nowrap" v-if="!request.editMode">{{ request.end_date }}</span>
                    </td>
                    <td class="align-td-left text-right text-monospace">
                      <input v-if="request.editMode" class="input-max-width" type="number"
                        @focus="$event.target.select()" v-model="request.baseline_costs">
                      <span v-if="!request.editMode">{{ numberWithSpaces(request.baseline_costs.toFixed(2)) }}</span>
                    </td>
                    <td class="align-td-left text-right text-monospace">
                      <input v-if="request.editMode" class="input-max-width" type="number"
                        @focus="$event.target.select()" v-model="request.additional_actuals">
                      <span v-if="!request.editMode">{{ numberWithSpaces(request.additional_actuals.toFixed(2))
                      }}</span>
                    </td>
                    <!--<td><input type="number" v-model="request.contingency"></td>-->
                    <td></td>
                    <td class="align-td-left text-right text-monospace">
                      <input v-if="request.editMode" class="input-max-width" type="number"
                        @focus="$event.target.select()" v-model="request.contract_budget">
                      <span v-if="!request.editMode">{{ numberWithSpaces(request.contract_budget.toFixed(2)) }}</span>
                    </td>
                    <td class="align-td-left">
                      <autocomplete id="contract-numbers-select-cr" :items="contractNumbers" :item="request.contract"
                        v-model="request.contract" v-if="request.editMode" :min-len="0" :auto-select-one-item="false"
                        :get-label="getContractLabel" :component-item='contractNumberListTemplate'
                        @update-items="updateContractNumbers">
                      </autocomplete>
                      <template v-if="!request.editMode">
                        <span v-if="request.contract" class="align-middle cursor-pointer"
                          @click="editContract(request.contract.id)">{{ request.contract.contract_number }}</span>
                        <span v-else class="align-middle"></span>
                      </template>
                    </td>
                    <td class="align-td-left text-right text-monospace">
                      <input v-if="request.editMode" type="number" class="input-max-width" min="0" step="1"
                        v-model.number="request.payment_due_days">
                      <span class="text-right text-monospace" v-if="!request.editMode">{{ request.payment_due_days
                      }}</span>
                    </td>
                    <td class="align-td-left text-right text-monospace">
                      <input v-if="request.editMode" type="number" class="input-max-width" min="0" step="1"
                        v-model.number="request.vat_rate">
                      <span class="text-right text-monospace" v-if="!request.editMode">{{ request.vat_rate }}</span>
                    </td>
                    <td>
                      <i v-if="request.editMode" class="fa fa-save fa-lg action" @click="updateChangeRequest(request)"
                        title="Update change request"></i>
                      <i v-if="!request.editMode && (!editChangeRequestObject.id || editChangeRequestObject.id == request.id)"
                        class="fa fa-edit fa-lg action" @click="editRequest(request, req)"
                        title="Edit change request"></i>
                      <i v-if="request.editMode" class="fa fa-remove fa-lg action"
                        @click="cancelRequestEdit(request, req)" title="Cancel change request"></i>
                      <i v-if="!request.editMode && (!editChangeRequestObject.id || editChangeRequestObject.id == request.id)"
                        class="fa fa-remove fa-lg action" @click="deleteChangeRequest(request)" aria-hidden="true"
                        title="Delete change request"></i>
                    </td>
                  </tr>
                  <tr v-for="(request, req) in newChangeRequests" v-if="newChangeRequests.length">
                    <td style="text-align: right;" colspan="4"><input class="input-max-width" placeholder="Enter name"
                        type="text" v-model="request.name"></td>
                    <td>
                      <datepicker placeholder="yyyy-mm-dd" input-class="new-change-request-date-picker"
                        :disabled-dates="{ from: new Date(request.end_date) }" v-model="request.start_date"
                        format="yyyy-MM-dd"></datepicker>
                    </td>
                    <td>
                      <datepicker placeholder="yyyy-mm-dd" input-class="new-change-request-date-picker"
                        :disabled="!request.start_date" :disabled-dates="{ to: new Date(request.start_date) }"
                        v-model="request.end_date" format="yyyy-MM-dd"></datepicker>
                    </td>
                    <td><input class="input-max-width" type="number" @focus="$event.target.select()"
                        v-model="request.baseline_costs"></td>
                    <td><input class="input-max-width" type="number" @focus="$event.target.select()"
                        v-model="request.additional_actuals"></td>
                    <td></td>
                    <!--<td><input type="number" v-model="request.contingency"></td>-->
                    <td><input class="input-max-width" type="number" @focus="$event.target.select()"
                        v-model="request.contract_budget"></td>
                    <td>
                      <autocomplete id="contract-numbers-select-cr" :items="contractNumbers" :item="request.contract"
                        v-model="request.contract" :min-len="0" :auto-select-one-item="false"
                        :get-label="getContractLabel" :component-item='contractNumberListTemplate'
                        @update-items="updateContractNumbers">
                      </autocomplete>
                    </td>
                    <td>
                      <input type="number" class="input-max-width" min="0" step="1"
                        v-model.number="request.payment_due_days">
                    </td>
                    <td>
                      <input type="number" class="input-max-width" min="0" step="1" v-model.number="request.vat_rate">
                    </td>
                    <td>
                      <i class="fa fa-save fa-lg action" @click="saveChangeRequest(request, project.id)"
                        title="Create change request"></i>
                      <i class="fa fa-remove fa-lg action" @click="cancelNewChangeRequest(request)" aria-hidden="true"
                        title="Cancel change request"></i>
                    </td>
                  </tr>
                  <tr v-if="project.change_requests.length">
                    <td class="ch-total-td text-right ch-total-text" colspan="6">Total</td>
                    <td class="ch-total-td ch-total-td-number text-monospace text-right">
                      {{ calculatedProjectData.baseline_costs ?
                          numberWithSpaces(calculatedProjectData.baseline_costs.toFixed(2)) : "0.00"
                      }}</td>
                    <td class="ch-total-td ch-total-td-number text-monospace text-right">
                      {{ calculatedProjectData.additional_actuals ?
                          numberWithSpaces(calculatedProjectData.additional_actuals.toFixed(2)) : "0.00"
                      }}</td>
                    <td class="ch-total-td"></td>
                    <td class="ch-total-td ch-total-td-number text-monospace text-right">
                      {{ calculatedProjectData.contract_budget ?
                          numberWithSpaces(calculatedProjectData.contract_budget.toFixed(2)) : "0.00"
                      }}</td>
                    <td class="ch-total-td"></td>
                  </tr>
                </span>
              </tbody>
            </table>
            <button class="m-0 btn btn-primary" @click="addNewChangeRequest()">New CR</button>
          </div>
        </div>
      </div>
      <!--/.col-->
    </div>
    <!--/.row-->
    <modal :backdrop="false" title="Modal title" v-model="editProjectModal" @ok="saveProject" ok-disabled="true"
      class="z-100" effect="fade/zoom">
      <div slot="modal-header" class="modal-header">
        <h4 class="modal-title">{{ currentProject.id ? "Edit" : "New" }} Project</h4>
      </div>
      <div class="form-group row" :class="validKey() ? 'has-success' : 'has-danger'">
        <label class="col-md-3 form-control-label">Key</label>
        <div class="col-md-9">
          <input type="text" class="form-control" placeholder="Key" v-model="currentProject.key"
            :disabled="currentProject.external_id">
        </div>
      </div>
      <div class="form-group row" :class="currentProject.name ? 'has-success' : 'has-danger'">
        <label class="col-md-3 form-control-label">Name</label>
        <div class="col-md-9">
          <input type="text" class="form-control" placeholder="Name" v-model="currentProject.name"
            :disabled="currentProject.external_id">
        </div>
      </div>
      <div class="form-group row" :class="currentProject.projectTypeKey ? 'has-success' : 'has-danger'">
        <label class="col-md-3 form-control-label">Type</label>
        <div class="col-md-9">
          <select v-model="currentProject.projectTypeKey" class="form-control" :disabled="currentProject.external_id">
            <option value="software">Software</option>
            <option value="business">Business</option>
          </select>
        </div>
      </div>
      <div class="form-group row" :class="currentProject.category_id ? 'has-success' : 'has-warning'">
        <label class="col-md-3 form-control-label">Category</label>
        <div class="col-md-9">
          <select v-model="currentProject.category_id" class="form-control" :disabled="currentProject.external_id">
            <option v-for="projectCategory in projectCategories" :key="projectCategory.id" :value="projectCategory.id">
              [{{ projectCategory.name }}] {{ projectCategory.description }}
            </option>
          </select>
        </div>
      </div>
      <div class="form-group row" :class="currentProject.client_id ? 'has-success' : 'has-warning'">
        <label class="col-md-3 form-control-label">Client</label>
        <div class="col-md-9">
          <select v-model="currentProject.client_id" class="form-control">
            <option :value="null">No client</option>
            <option v-for="client in clients" :key="client.id" :value="client.id">{{ client.name }}</option>
          </select>
        </div>
      </div>
      <div class="form-group row" :class="currentProject.start_date ? 'has-success' : 'has-warning'">
        <label class="col-md-3 form-control-label">Start date</label>
        <div class="col-md-9">
          <datepicker placeholder="yyyy-mm-dd"
            :input-class="{ 'edit-project-date-picker-filled': currentProject.start_date, 'edit-project-date-picker-empty': !currentProject.start_date }"
            :disabled-dates="getDisabledDate('from', currentProject.end_date)" v-model="currentProject.start_date"
            format="yyyy-MM-dd"></datepicker>
        </div>
      </div>
      <div class="form-group row" :class="currentProject.end_date ? 'has-success' : 'has-warning'">
        <label class="col-md-3 form-control-label">End date</label>
        <div class="col-md-9">
          <datepicker placeholder="yyyy-mm-dd" :input-class="['edit-project-date-picker', {
            'edit-project-date-picker-filled': currentProject.end_date,
            'edit-project-date-picker-empty': !currentProject.end_date
          }]" :disabled="!currentProject.start_date" :disabled-dates="getDisabledDate('to', currentProject.start_date)"
            v-model="currentProject.end_date" format="yyyy-MM-dd"></datepicker>
        </div>
      </div>
      <div class="form-group row" :class="currentProject.estimated_end_date ? 'has-success' : 'has-warning'">
        <label class="col-md-3 form-control-label">Estimated end date</label>
        <div class="col-md-9">
          <datepicker placeholder="yyyy-mm-dd" :clear-button="true" :input-class="['edit-project-date-picker', {
            'edit-project-date-picker-filled': currentProject.estimated_end_date,
            'edit-project-date-picker-empty': !currentProject.estimated_end_date
          }]" :disabled="!currentProject.start_date" :disabled-dates="getDisabledDate('to', currentProject.start_date)"
            v-model="currentProject.estimated_end_date" format="yyyy-MM-dd"></datepicker>
        </div>
      </div>
      <div class="form-group row" :class="currentProject.reference_start_date ? 'has-success' : 'has-warning'">
        <label class="col-md-3 form-control-label">Reference start date</label>
        <div class="col-md-9">
          <datepicker placeholder="yyyy-mm-dd" :clear-button="true" :input-class="['edit-project-date-picker', {
            'edit-project-date-picker-filled': currentProject.reference_start_date,
            'edit-project-date-picker-empty': !currentProject.reference_start_date
          }]" :disabled="!currentProject.start_date" :disabled-dates="getDisabledDate('to', currentProject.start_date)"
            v-model="currentProject.reference_start_date" format="yyyy-MM-dd"></datepicker>
        </div>
      </div>
      <div class="form-group row" :class="currentProject.baseline_costs ? 'has-success' : 'has-warning'">
        <label class="col-md-3 form-control-label">Estimated completition</label>
        <div class="col-md-9 input-group">
          <span class="input-group-addon">%</span>
          <input type="number" class="form-control" min="0" max="100" step="0.01"
            v-model.number="currentProject.estimated_completition">
        </div>
      </div>

      <div class="form-group row" :class="currentProject.baseline_costs ? 'has-success' : 'has-warning'">
        <label class="col-md-3 form-control-label">Baseline costs</label>
        <div class="col-md-9 input-group">
          <span class="input-group-addon"><i class="fa fa-euro"></i></span>
          <input type="number" class="form-control" min="0" step="0.01" v-model.number="currentProject.baseline_costs">
        </div>
      </div>
      <div class="form-group row">
        <label class="col-md-3 form-control-label">Additional actuals</label>
        <div class="col-md-9 input-group">
          <span class="input-group-addon"><i class="fa fa-euro"></i></span>
          <input type="number" class="form-control" min="0" step="0.01"
            v-model.number="currentProject.additional_actuals">
        </div>
      </div>
      <div class="form-group row" :class="currentProject.contingency ? 'has-success' : 'has-warning'">
        <label class="col-md-3 form-control-label">Contingency</label>
        <div class="col-md-9 input-group">
          <span class="input-group-addon"><i class="fa fa-euro"></i></span>
          <input type="number" class="form-control" min="0" step="0.01" v-model.number="currentProject.contingency">
        </div>
      </div>
      <div class="form-group row" :class="currentProject.contract_budget ? 'has-success' : 'has-warning'">
        <label class="col-md-3 form-control-label">Contract budget</label>
        <div class="col-md-9 input-group">
          <span class="input-group-addon"><i class="fa fa-euro"></i></span>
          <input type="number" class="form-control" min="0" step="0.01" v-model.number="currentProject.contract_budget">
        </div>
      </div>

      <div class="form-group row" :class="currentProject.contract_id ? 'has-success' : 'has-warning'">
        <label class="col-md-5 form-control-label">Contract number</label>
        <div class="col-md-7">
          <autocomplete id="contract-numbers-select" :items="contractNumbers" :item="currentProject.contract"
            v-model="currentProject.contract" :min-len="0" :auto-select-one-item="false" :get-label="getContractLabel"
            :component-item='contractNumberListTemplate' @update-items="updateContractNumbers">
          </autocomplete>
        </div>
      </div>
      <div class="form-group row" :class="currentProject.vat_rate ? 'has-success' : 'has-warning'">
        <label class="col-md-5 form-control-label">VAT rate (0 for no VAT)</label>
        <div class="col-md-7 input-group">
          <span class="input-group-addon"><i class="fa fa-percent"></i></span>
          <input type="number" class="form-control" min="0" step="1" v-model.number="currentProject.vat_rate">
        </div>
      </div>
      <div class="form-group row" :class="currentProject.payment_due_days ? 'has-success' : 'has-warning'">
        <label class="col-md-5 form-control-label">Payment due in days</label>
        <div class="col-md-7 input-group">
          <span class="input-group-addon"><i class="fa fa-calendar"></i></span>
          <input type="number" class="form-control" min="0" step="1" v-model.number="currentProject.payment_due_days">
        </div>
      </div>

      <div class="form-group row">
        <label class="col-md-5 form-control-label">Automatically update start and end date</label>
        <div class="col-md-7 input-group">
          <label class="switch switch-text switch-primary">
            <input type="checkbox" v-model="currentProject.jira_import_enabled" class="switch-input" checked>
            <span class="switch-label" data-on="On" data-off="Off"></span>
            <span class="switch-handle"></span>
          </label>
        </div>
      </div>
    </modal>
  </div>
</template>
<style lang="scss" scoped>
.cursor-pointer {
  cursor: pointer;
}

.v-autocomplete-input {
  display: block;
  width: 100%;
  padding: 0.5rem 0.75rem;
  font-size: 0.875rem;
  line-height: 1.25;
  color: #607d8b;
  background-color: #fff;
  background-image: none;
  background-clip: padding-box;
  border: 1px solid rgba(0, 0, 0, 0.15);
  border-radius: 0;
}

.v-autocomplete-list-item {
  cursor: pointer;
  padding: 5px;
  border: 1px solid rgba(0, 0, 0, 0.15);
}

.v-autocomplete-list-item:hover {
  background-color: #e6e6e6;
}

.new-project-btn {
  float: right;
  margin-bottom: 10px;
}

.action {
  margin-left: 5px;

  &:hover {
    cursor: pointer;
    color: #ee0044;
  }
}

a {
  color: inherit;
}

th,
td {
  padding: 0.2rem;
}

tbody>tr:hover {
  background-color: #c8d2d2;
}

.z-100 {
  z-index: 100;
}

.span-row {
  display: contents;
}

.input-max-width {
  width: 100%;
  height: 22px;
}

.ch-total-td {
  font-weight: bold;
}

.ch-total-text {
  padding-right: 5px;
}

.align-td-left span {
  text-align: left;
}

.ch-total-td-number {
  text-align: left;
  padding-left: 5px;
}

.pad-left {
  padding-left: 5px;
}
</style>
<style>
#contract-numbers-select .v-autocomplete-list,
#contract-numbers-select-cr .v-autocomplete-list {
  width: 100%;
  z-index: 200 !important;
  position: absolute;
  text-align: left;
  border: 1px solid rgba(0, 0, 0, 0.15);
  border-radius: 0;
  max-height: 200px;
  overflow-y: auto;
  /*border-bottom: 1px solid #157977;*/
}

#contract-numbers-select-cr .v-autocomplete-input {
  padding: 0;
  height: 22px;
  border-color: -internal-light-dark(rgb(118, 118, 118), rgb(195, 195, 195));
  border: 1px solid;
  border-radius: 2px;
}

.new-change-request-date-picker {
  width: 100%;
  color: #607d8b;
  padding-left: 10px;
  height: 22px;
}

.update-change-request-date-picker {
  width: 100%;
  height: 22px;
}

.edit-project-date-picker-empty {
  width: 100%;
  border: 1px solid #f8cb00;
  color: #607d8b;
  padding: 0.5rem 0.75rem;
}

.edit-project-date-picker-filled {
  width: 100%;
  border: 1px solid #4dbd74;
  color: #607d8b;
  padding: 0.5rem 0.75rem;
}
</style>

<script>
import { mapGetters, mapActions, mapState } from 'vuex';
import modal from 'vue-strap/src/Modal';
import VueNotifications from 'vue-notifications';
import Datepicker from 'vuejs-datepicker';
import moment from 'moment';
import Autocomplete from 'v-autocomplete';
import Vue from 'vue';
import ProjectCategoryFilter from './ProjectCategoryFilter.vue';
import ContractNumbersDropdownItem from '../documents/ContractNumbersDropdownItem.vue';

export default {
  name: 'Projects',
  components: {
    modal,
    ProjectCategoryFilter,
    Datepicker,
    Autocomplete
  },
  data: function () {
    return {
      currentProject: {},
      contractNumberListTemplate: ContractNumbersDropdownItem,
      editProjectModal: false,
      categoryFilter: {},
      expanded: false,
      contractNumbers: [],
      newChangeRequests: [],
      savedChangeRequest: {},
      updateChangeRequestObject: {},
      editChangeRequestObject: {},
      calculatedProjectData: {
        baseline_costs: 0,
        contract_budget: 0
      }
    };
  },
  watch: {
    'currentProject.contract': function (val) {
      if (val !== null && typeof val !== 'undefined') {
        this.currentProject.contract_id = val.id;
      } else {
        this.currentProject.contract_id = null;
      }
    },
    'editChangeRequestObject.contract': function (val) {
      if (val !== null && typeof val !== 'undefined') {
        this.editChangeRequestObject.contract_id = val.id;
      } else {
        this.editChangeRequestObject.contract_id = null;
      }
    },
    newChangeRequests: {
      handler: function (newChangeRequests) {
        newChangeRequests.forEach((request, key) => {
          console.log(request);
          if (request.contract) {
            this.newChangeRequests[key].contract_id = request.contract.id;
          } else {
            this.newChangeRequests[key].contract_id = null;
          }
        });
      },
      deep: true
    },
    editProjectModal: function (val) {
      // if (val) {
      //   $('#projectsRoot').parent().css('z-index', 3000);
      // } else {
      //   setTimeout(() => {
      //     $('#projectsRoot').parent().css('z-index', 0);
      //   }, 300);
      // }
    },
    changeRequestNotification: {
      handler: function (val) {
        if (this.changeRequestNotification.status == 'success') {
          this.showSuccessMsg({ title: 'Change request status', message: this.changeRequestNotification.message });
          if (this.savedChangeRequest) {
            this.newChangeRequests.splice(this.newChangeRequests.indexOf(this.savedChangeRequest), 1);
            this.$store.state.JiraProjects.changeRequestNotification = {
              data: {},
              message: '',
              status: 'loading'
            };
            this.savedChangeRequest = {};
          }
          if (this.updateChangeRequestObject) {
            for (const i in this.projects[this.updateChangeRequestObject.project_id].change_requests) {
              if (this.projects[this.updateChangeRequestObject.project_id].change_requests[i].id == this.updateChangeRequestObject.id) {
                this.projects[this.updateChangeRequestObject.project_id].change_requests[i].editMode = false;
              }
            }
            this.editChangeRequestObject = {};
          }
          this.calculateProjectChangeRequests();
        }
        if (this.changeRequestNotification.status == 'error') {
          for (const i in this.changeRequestNotification.message) {
            this.showErrorMsg({ title: 'Change request status', message: this.changeRequestNotification.message[i] });
          }
        }
      },
      deep: true
    },
    projects: function () {
      this.calculateProjectChangeRequests();
    }
  },
  props: {
    showNewProject: {
      default: true
    },
    showCategoryFilter: {
      default: true,
    },
    showHeader: {
      default: true,
    },
    projectId: null,
  },
  computed: {
    ...mapGetters('JiraProjects', ['projects', 'projectCategories', 'changeRequestNotification']),
    ...mapGetters('Clients', ['clients']),
  },
  methods: {
    ...mapActions('JiraProjects', [
      'SAVE_JIRA_PROJECT',
      'UPDATE_PROJECT_META',
      'SAVE_CHANGE_REQUEST',
      'DELETE_CHANGE_REQUEST'
    ]),
    ...mapActions('Clients', ['GET_CLIENTS_LIST', 'SEARCH_CONTRACTS']),
    editProject(project) {
      this.currentProject = { ...project };

      this.editProjectModal = true;
    },
    newProject() {
      this.currentProject = {
        active: 1,
      };
      this.editProjectModal = true;
    },
    saveProject() {
      if (this.currentProject.key && this.currentProject.name && this.currentProject.projectTypeKey) {
        this.currentProject.start_date = moment(this.currentProject.start_date).format('YYYY-MM-DD');
        this.currentProject.end_date = moment(this.currentProject.end_date).format('YYYY-MM-DD');
        this.currentProject.estimated_end_date = this.currentProject.estimated_end_date
          ? moment(this.currentProject.estimated_end_date).format('YYYY-MM-DD') : null;
        this.currentProject.reference_start_date = this.currentProject.reference_start_date
          ? moment(this.currentProject.reference_start_date).format('YYYY-MM-DD') : null;
        if (this.currentProject.contract === null) this.currentProject.contract_id = null;
        this.SAVE_JIRA_PROJECT(this.currentProject);
        this.currentProject = {};
        this.editProjectModal = false;
      }
    },
    validKey() {
      if (!this.currentProject.key) return false;
      for (const projectId in this.projects) {
        if (this.projects[projectId].key == this.currentProject.key && projectId != this.currentProject.id) return false;
      }
      return true;
    },
    clientName(clientId) {
      if (!clientId) return;
      for (const i in this.clients) {
        if (this.clients[i].id == clientId) {
          return this.clients[i].name;
        }
      }
    },
    setAllCategoriesActive() {
      for (const categoryId in this.projectCategories) {
        Vue.set(this.categoryFilter, categoryId, true);
      }
      Vue.set(this.categoryFilter, 'active', true);
      Vue.set(this.categoryFilter, null, true);
    },
    showProject(projectId) {
      if (this.projectId) {
        if (this.projectId == projectId) {
          if (!this.editChangeRequestObject.id) {
            for (const i in this.projects[projectId].change_requests) {
              this.projects[projectId].change_requests[i].editMode = false;
            }
          }
          return true;
        }
        return false;
        //        return this.projectId == projectId;
      }
      const active = this.projects[projectId].start_date && (!this.projects[projectId].end_date || new Date(this.projects[projectId].end_date) > new Date());
      if ((!this.categoryFilter['active'] || active) && this.categoryFilter[this.projects[projectId].category_id]) {
        if (!this.editChangeRequestObject.id) {
          for (const i in this.projects[projectId].change_requests) {
            this.projects[projectId].change_requests[i].editMode = false;
          }
        }
        return true;
      }
      return false;
    },
    addNewChangeRequest() {
      this.newChangeRequests.push({
        start_date: '',
        end_date: '',
        baseline_costs: 0,
        additional_actuals: 0,
        contingency: 0,
        contract_budget: 0,
        project_id: null,
        contract_id: null,
        vat_rate: null,
        payment_due_days: null,
        contract: {},
        name: ''
      });
    },
    saveChangeRequest(request, project_id) {
      request.project_id = project_id;
      request.end_date = moment(request.end_date).format('YYYY-MM-DD');
      request.start_date = moment(request.start_date).format('YYYY-MM-DD');
      this.savedChangeRequestIndex = request;
      this.SAVE_CHANGE_REQUEST(request);
      //          this.cancelNewChangeRequest(request);
    },
    updateChangeRequest(request) {
      this.updateChangeRequestObject = request;
      request.end_date = moment(request.end_date).format('YYYY-MM-DD');
      request.start_date = moment(request.start_date).format('YYYY-MM-DD');
      this.SAVE_CHANGE_REQUEST(request);
    },
    editRequest(request, req) {
      if (this.editChangeRequestObject.id) {
        return;
      }
      request.editMode = true;
      this.editChangeRequestObject = request;
      this.updateContractNumbers('');
      Vue.set(this.projects[request.project_id].change_requests, req, request);
    },
    cancelRequestEdit(request, req) {
      request.editMode = false;
      this.editChangeRequestObject = {};
      Vue.set(this.projects[request.project_id].change_requests, req, request);
    },
    cancelNewChangeRequest(request) {
      this.newChangeRequests.splice(this.newChangeRequests.indexOf(request), 1);
    },
    deleteChangeRequest(request) {
      this.DELETE_CHANGE_REQUEST(request);
    },
    calculateProjectChangeRequests() {
      if (this.projectId) {
        if (this.projects[this.projectId]) {
          const project = this.projects[this.projectId];
          let baseline_costs = project.baseline_costs;
          let additional_actuals = project.additional_actuals;
          let contract_budget = project.contract_budget;
          for (const i in project.change_requests) {
            baseline_costs += project.change_requests[i].baseline_costs;
            additional_actuals += project.change_requests[i].additional_actuals;
            contract_budget += project.change_requests[i].contract_budget;
          }
          this.calculatedProjectData = {
            baseline_costs: baseline_costs,
            additional_actuals: additional_actuals,
            contract_budget: contract_budget
          };
        }
      }
    },
    openProject(project_id) {
      this.$router.push({ name: 'ProjectTabPlanning', params: { id: project_id } });
    },
    getDisabledDate(type, date) {
      if (type === 'from') {
        if (!date) date = moment().add(1, 'year').startOf('year').format('YYYY-MM-DD');
        return { from: new Date(date) };
      } if (type === 'to') {
        if (!date) date = moment().startOf('year').format('YYYY-MM-DD');
        return { to: new Date(date) };
      }
      return {};
    },
    numberWithSpaces(x) {
      return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
    },
    updateContractNumbers(text) {
      this.SEARCH_CONTRACTS(text).then((response) => {
        this.contractNumbers = response.data.data;
      }, (err) => {

      });
    },
    getContractLabel(item) {
      if (item !== null && typeof item !== 'undefined') {
        return item.contract_number;
      }
      return '';
    },
    editContract(contractID) {
      this.$router.push({ name: 'EditContract', params: { id: contractID } });
    },
  },
  notifications: {
    showSuccessMsg: {
      type: VueNotifications.types.success
    },
    showInfoMsg: {
      type: VueNotifications.types.info
    },
    showWarnMsg: {
      type: VueNotifications.types.warn
    },
    showErrorMsg: {
      type: VueNotifications.types.error
    }
  },
  mounted() {
    this.GET_CLIENTS_LIST();
    this.setAllCategoriesActive();
    this.calculateProjectChangeRequests();
  }
};
</script>
